import React from 'react'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import { NAVBAR_HEIGHT } from './Navbar'

export const SIDEBAR_WIDTH = 300

const CommonSidebar: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <>
      <Paper
        square
        variant="outlined"
        sx={{
          position: 'fixed',
          width: SIDEBAR_WIDTH,
          overflow: 'auto',
          bottom: 0,
          top: NAVBAR_HEIGHT,
        }}
      >
        {children}
      </Paper>
      <Box sx={{ minWidth: SIDEBAR_WIDTH }} />
    </>
  )
}

export default CommonSidebar
